import { Tooltip } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useLocation } from 'react-router-dom'

import { userCanPerformAction } from '@/auth/authorizations'
import { useAuth } from '@/auth/use-auth'
import ModalNewCustomer from '@/components/ModalNewCustomer'
import { EmmaPath } from '@/router/paths'
import { useCustomerFormStore } from '@/stores/useCustomerFormStore'

import ButtonContent from './ButtonContent'

const AddCustomerButton = ({ openedSidebar }: { openedSidebar: boolean }) => {
  const { userRoles } = useAuth()
  const location = useLocation()
  const isDirty = useCustomerFormStore((state) => state.isDirty)

  const [opened, { toggle }] = useDisclosure(false)

  const userCanAddCustomer = userCanPerformAction(false, userRoles, EmmaPath.CUSTOMER_CREATE)

  if (!userCanAddCustomer) return null

  const isOnCustomerPage = location.pathname.includes('/customer/')
  const shouldDisable = isOnCustomerPage && isDirty

  const tooltipLabel = shouldDisable
    ? 'Please save current customer changes before adding a new customer'
    : 'Add customer'

  return (
    <>
      <ModalNewCustomer opened={opened} onClose={toggle} />
      <Tooltip label={tooltipLabel} disabled={!shouldDisable}>
        <ButtonContent openedSidebar={openedSidebar} toggle={toggle} shouldDisable={shouldDisable} />
      </Tooltip>
    </>
  )
}

export default AddCustomerButton
